    export const AssetPath = '/assets/v1.627.2-beta';
